module.exports = __webpack_public_path__ + "static/DSC_9419-7b771bf6c10352343547b8b7efbd27ee.jpg";